// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"57":"index","945":"dashboard"}[chunkId] + "." + {"57":"43e59a9e","945":"bf477e6a"}[chunkId] + ".js";
};